import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { adsListViews } from 'Core/constants'

export const GridView = ({ onClick, style }) => {
  const { t } = useTranslation('common')

  return (
    <li onClick={onClick} className={style === adsListViews.TABLE ? 'active' : ''}>
      <span className='oglasi-filter-grid_item'><i className='ico-filter-prikaz-grid-tekst ico' /></span>
      <div className='tooltip'>{t('Slikovni prikaz')}</div>
    </li>
  )
}

GridView.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.oneOf([
    adsListViews.LIST,
    adsListViews.TABLE
  ])
}

GridView.defaultProps = {
  onClick: () => { }
}
